import { render, staticRenderFns } from "./BaseMetadatoFormItem.vue?vue&type=template&id=8ed6b8d2&scoped=true"
import script from "./BaseMetadatoFormItem.vue?vue&type=script&lang=js"
export * from "./BaseMetadatoFormItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed6b8d2",
  null
  
)

export default component.exports